// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8488ae9","239":"c49111d3","453":"81aa32be","553":"7bb49de5"}[chunkId] + ".chunk.js";
};